export const PUBLISHED_NEWS = "publishedNews";
export const PUBLISHED_NEWS_LAST_FETCH_WAS_EMPTY = "publishedNewsLastFetchWasEmpty";
export const ALL_IMAGES_IN_CONTENT = "pictureRefsWithWebItems";
export const SELECTED_COVER_PICTURE = "selectedCoverPicture";
export const CURRENT_NEWS = "currentNews";
export const CURRENT_NEWS_UID = "currentNewsUid";
export const IS_LOADING_PUBLISHED_NEWS = "isLoadingPublishedNews";
